export function buildFilterExpression(
  ...conditions: (string | false | null | undefined)[]
): string {
  return conditions
    .filter((condition): condition is string => Boolean(condition))
    .join(" && ");
}
